<script setup lang="ts">
import type { CarModel } from '#shared/interfaces/car-model-list/model'

const { modelContents } = defineProps<{ modelContents: CarModel }>()
const nuxtApp = useNuxtApp()
const route = useRoute()
const query = route.query
const clickCount = useState<number>('click_count')

const newCarPrice: (string | number)[] = nuxtApp.$createDisplayCarPrice(
  modelContents.newcar_price_lower_limit,
  modelContents.newcar_price_upper_limit
)

const moveToModelTop = (modelCd: number, carCd: number) => {
  clickCount.value += 1
  if (clickCount.value === 1) {
    nuxtApp.$sendEventGaTag('CatalogListCarCassetteTap')
    navigateTo({
      path: '/model-top/' + modelCd + '_' + carCd,
      query,
    })
  }
}
const reviewAveragePoint = modelContents.review_average_point ?? 0
</script>

<template>
  <div class="wrapper">
    <div v-if="modelContents.current_model_flg" class="current-model">
      <div class="purchase">現行販売車</div>
    </div>
  </div>
  <div
    class="row"
    @click="moveToModelTop(modelContents.car_cd, modelContents.model_cd)"
  >
    <div class="col-auto col_check">
      <div style="margin: 0 0 0 0.5rem">
        <img
          class="car-img"
          :class="[modelContents.current_model_flg ? 'current' : '']"
          :src="modelContents.image"
          :alt="modelContents.car_name"
          onerror="
            this.src = 'https://img.goo-net.com/goo/usedcar/nophoto_big.jpg'
          "
          loading="lazy"
        />
      </div>
    </div>
    <div class="col model_info underscore-link">
      <div class="status-caset">
        <div class="status-detail">
          <div class="brand_name">
            {{ modelContents.brand_name }}
          </div>
          <div class="car_name">
            {{ modelContents.car_name }}
          </div>
          <div
            v-if="
              modelContents.sales_start_date && modelContents.current_model_flg
            "
            class="sales-data"
          >
            {{ modelContents.sales_start_date_jpn }}〜販売中
          </div>
          <div
            v-else-if="
              modelContents.sales_start_date && modelContents.sales_end_date
            "
            class="sales-data"
          >
            {{ modelContents.sales_start_date_jpn }}〜<br />{{
              modelContents.sales_end_date_jpn
            }}
          </div>
          <div class="score">
            <span class="average-point">
              {{
                String(reviewAveragePoint).split('.').length === 2 ||
                reviewAveragePoint === 0
                  ? reviewAveragePoint
                  : reviewAveragePoint + '.0'
              }}</span
            >
            <NuxtRating
              :rating-value="Math.floor(Number(reviewAveragePoint))"
              :read-only="true"
              inactive-color="#E7E9ED"
              active-color="#FFDC4A"
              rating-size="12px"
            />
          </div>
          <div class="newcar-price">
            <div>
              <span class="title">新車時価格<br /></span>
              <span v-if="newCarPrice.length === 1" class="price">{{
                newCarPrice[0]!.toLocaleString()
              }}</span>
              <span v-else class="price">
                {{ newCarPrice[0]!.toLocaleString()
                }}<span class="hyphen">〜</span
                >{{ newCarPrice[1]!.toLocaleString() }}
              </span>
              <span class="unit">円</span>
            </div>
          </div>
        </div>
        <div class="col_link">
          <img
            style="width: 24px; height: 24px"
            src="@/assets/image/icon/arrow_right.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.row {
  height: auto;
  display: flex;
  margin: 0;
  padding-bottom: 7px;
  padding-top: 10px;
  border-bottom: 1px solid #ecf0f2;
  position: relative;
}

.row:before {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 8px;
  height: inherit;
  border-bottom: 1px solid #ffffff;
}

.col .col-auto {
  align-items: center;
}

.col_check {
  padding: 0;
}

.purchase {
  font-size: 10px;
  background-color: #000000;
  color: #ffffff;
  border-radius: 2px;
  text-align: center;
  padding: 2px;
  overflow-wrap: break-word;
  width: 58px;
}

.car-img {
  width: 90px;
  height: 45px;
  margin-top: 10px;
  vertical-align: middle;
  object-fit: cover;
}

.model_info {
  text-align: left;
  padding: 0 0 0 6px;
}
img.current {
  margin-top: 26px;
}
.car_name {
  margin-top: 2px;
  font-size: 12px;
  font-weight: bold;
}

.score {
  font-size: 16px;
  font-weight: bold;
  color: #df2020;
  display: flex;
  align-items: center;
}

.newcar-price {
  font-size: 11px;
}

.title {
  font-size: 11px;
}

.price {
  font-size: 11px;
  color: #333333;
}

.hyphen {
  font-size: 11px;
  font-weight: bold;
}

.unit {
  font-size: 11px;
  color: #333333;
}

.col_link {
  margin: auto 8px auto 0;
}

i {
  color: #e00923;
  font-size: 16px;
  vertical-align: middle;
}

.underscore-link {
  color: #000000;
}

.sales-data {
  font-size: 11px;
}

.status-caset {
  display: flex;
  justify-content: space-between;
}

.status-detail {
  min-width: 175px;
}

.current-model {
  position: relative;
  margin-bottom: -20px;
  top: 10px;
  padding: 0px 0px 0px 16px;
  width: 98px;
}

.average-point {
  margin-right: 5px;
}
</style>
